export enum ServiceRequestTypes {
    Prior = 'Prior',
    Concurrent = 'Concurrent',
    Retro = 'Retro',
    Reopen = 'Reopen',
    ContinuedStay = 'Continued Stay'
}

export const RequestType = {
  Initial: 'Initial',
  Reauthorization: 'Reauthorization',
  Retro: 'Retro'
};
